import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatCard, MatCardContent } from '@angular/material/card';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-unauthorized',
    imports: [MatCard, MatCardContent, RouterLink],
    templateUrl: './unauthorized.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './unauthorized.component.scss'
})
export class UnauthorizedComponent {}
